<mat-dialog-content>
    <form (submit)="submit()">
        <mat-form-field appearance="outline" floatLabel="always" subscriptSizing="dynamic">
            <mat-label>{{ 'Gate.DeviceCode' | translate }}</mat-label>
            <input #dmiCodeInput matInput name="deviceCode" [(ngModel)]="deviceCode" autocomplete="off" />
        </mat-form-field>
    </form>
</mat-dialog-content>
<mat-dialog-actions>
    <button mat-button mat-dialog-close>{{ 'General.Cancel' | translate }}</button>
    <button mat-button (click)="submit()">{{ 'General.Ok' | translate }}</button>
</mat-dialog-actions>
